// import { useState, useEffect } from 'react'
// import ApiClient from '../../api/client'
// import Navbar from '../Navbar'
// import { toast } from 'react-toastify'


// const api = new ApiClient();

// const DashboardHome = () => {
//     const [client, setClient] = useState([])
//     const [clientId, setClientId] = useState(null)
//     const [clientName, setClientName] = useState("")
//     const [clientEmail, setClientEmail] = useState("")
//     const [program, setProgram] = useState("")
//     const [status, setStatus] = useState("")


//     const fetchClient = async() => {
//         const response = await api.getClientDetails(clientId)
//         setClient(response.data)
    
//     }


//     const handleSubmit = async(e) => {
//       e.preventDefault();
//       if(clientId) {
//         await api.updateClientDetails(clientId)
//       }else{
//         await api.createClient(clientName, clientEmail, program, status)
//         }

//         setClientName("")
//         setClientEmail("")
//         setStatus("")
//         setProgram("")
//         setClientId(null)
//         fetchClient()

//       }

//       const handleEdit = async(client) => {
//         setClientName(client.clientName)
//         setClientEmail(client.clientEmail)
//         setStatus(client.status)
//         setProgram(client.program)
//         setClientId(client.clientId)
//         fetchClient()
//       }

//       const handleDelete = async() => {
//         await api.deleteClient(clientId)
//       }

//     useEffect(()=>{
//       fetchClient();
//     }, [])

//   return (
//     <div>
//       <Navbar />
//       {/* Dashboard section */}
//       <div>
//         <form onSubmit={handleSubmit}>
//           <input type="text" value={clientName} onChange={(e) => setClientName(e.target.value)} placeholder='Input client name' required/>
//           <input type="text" value={clientEmail} onChange={(e) => setClientEmail(e.target.value)} placeholder='Input client email'/>
//           <select onChange={(e) => setStatus(e.target.value)} value={status} placeholder='Select status'>
//             <option value="pending">Pending</option>
//             <option value="verified">Verified</option>
//           </select>
//           <div>
//             <button type="submit">{clientId ? 'update':'Add'}</button>
//           </div>
//         </form>
//       </div>

//       <div>
//         <ul>
//           {client.map(item => (
//             <li key={item.id}>
//               <span>{item.clientName}</span>
//               <div>
//                 <button onClick={handleEdit(item)}>Edit</button>
//                 <button onClick={handleDelete(item)}>Delete</button>
//               </div>
//             </li>
//           ))
//           }
//         </ul>
//       </div>
    
//     </div>
//   )
// }

// export default DashboardHome



// import { useState, useEffect } from 'react';
// import ApiClient from '../../api/client';
// import Navbar from '../Navbar';
// import { toast } from 'react-toastify';

// const api = new ApiClient();

// const Dashboard = () => {
//   const [clients, setClients] = useState([]);
//   const [clientId, setClientId] = useState(null);
//   const [clientName, setClientName] = useState('');
//   const [clientEmail, setClientEmail] = useState('');
//   const [program, setProgram] = useState('');
//   const [status, setStatus] = useState('');

//   const fetchClients = async () => {
//     const response = await api.getAllClients(); // No clientId to fetch all
//     if (response.data) {
//       setClients(response.data);
//     } else {
//       toast.error(response.error);
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (clientId) {
//       const res = await api.updateClientDetails(clientId, clientName, clientEmail, status);
//       if (res.error) toast.error(res.error);
//     } else {
//       const res = await api.createClient(clientName, clientEmail, program, status);
//       if (res.error) toast.error(res.error);
//     }

//     setClientName('');
//     setClientEmail('');
//     setProgram('');
//     setStatus('');
//     setClientId(null);

//     await fetchClients();
//   };

//   const handleEdit = (client) => {
//     setClientName(client.name);
//     setClientEmail(client.email);
//     setStatus(client.status);
//     setProgram(client.program);
//     setClientId(client.id);
//   };

//   const handleDelete = async (id) => {
//     const res = await api.deleteClient(id);
//     if (res.error) toast.error(res.error);
//     await fetchClients();
//   };

//   useEffect(() => {
//     fetchClients();
//   }, []);

//   return (
//     <div className='bg-white'>
//       <Navbar />
      
//       <div className='relative isolate w-full pt-40 px-8'>
//         <form onSubmit={handleSubmit}>
//           <input
//             type="text"
//             value={clientName}
//             onChange={(e) => setClientName(e.target.value)}
//             placeholder="Input client name"
//             required
//           />
//           <input
//             type="email"
//             value={clientEmail}
//             onChange={(e) => setClientEmail(e.target.value)}
//             placeholder="Input client email"
//             required
//           />
//           <input
//             type="text"
//             value={program}
//             onChange={(e) => setProgram(e.target.value)}
//             placeholder="Input program"
//             required
//           />
//           <select onChange={(e) => setStatus(e.target.value)} value={status} required>
//             <option value="">Select status</option>
//             <option value="pending">Pending</option>
//             <option value="verified">Verified</option>
//           </select>

//           <div>
//             <button type="submit">{clientId ? 'Update' : 'Add'}</button>
//           </div>
//         </form>
//       </div>

//       <div>
//         <ul>
//           {clients.map((item) => (
//             <li key={item.id}>
//               <span>{item.client_name} — {item.email}</span>
//               <div>
//                 <button onClick={() => handleEdit(item)}>Edit</button>
//                 <button onClick={() => handleDelete(item.id)}>Delete</button>
//               </div>
//             </li>
//           ))}
//         </ul>
//       </div>
//     </div>
//   );
// };

// export default Dashboard;


// src/components/ClientTable.js

// import { toast } from 'react-toastify';
import Navbar from '../components/Navbar';
import ClientTable from '../components/client_components/index';

const Home = () => {

  return (
    <div className="">
      <div>
        {/* <Navbar />       */}
      </div>
      <div>
        <ClientTable />      
      </div>

    </div>
  );
};

export default Home;
